import { Modal, Button } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import GraphQLService from "network/graphql.service";
import { DELETE_ARTICLE } from "models/mutations/article.mutations";
import { LOAD_ARTICLES } from "models/queries/article.queries";
import { IArticle } from "sthinds.io-lib";
import React from "react";

interface DeleteArticleProps {
  article: IArticle;
  show: boolean;
  onClose: () => void;
}

export default function DeleteArticleComponent({
  article,
  show,
  onClose,
}: DeleteArticleProps): JSX.Element {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  async function deleteArticle(): Promise<void> {
    setError(null);
    try {
      await GraphQLService.mutate({
        mutation: DELETE_ARTICLE,
        variables: { _id: article._id },
      });
      await GraphQLService.refetchQueries({ include: [LOAD_ARTICLES] });
      onClose();
      navigate("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not delete the article.");
    }
  }

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Article "{article.title}"</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>This action is irreversible. Are you sure you want to proceed?</p>
        {error ? <p className="article-form-error" role="alert">{error}</p> : null}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={deleteArticle}>
          Delete
        </Button>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
